import React from 'react';
import { withImageOptimizerBySizeAndType } from 'Utils/Content';
import './ExclusiveContent.css';

export const ExclusiveContent = (data) => {
  const { headline, member: modules } = data;
  if (headline && modules) {
    return (
      <div className="exclusiveContentContainer">
        <div className="contentTitle sectionBorder">
          <span className="sectionHeadline">{headline}</span>
        </div>
        <div className="contentModules">
          {modules.map((item, i) => {
            const imageFormat = i % 2 === 0 ? 'jpg' : 'png';
            const defaultImageCropSize = 1200;
            const {
              images: { promoImage: image },
            } = item;
            return (
              <div className="contentInfo" key={`content-${i}`}>
                <div className="contentInfoCopy">
                  <span className="contentInfoHeadline">{item.headline}</span>
                  <p className="contentInfoParagraph">{item.description}</p>
                </div>
                <div className="contentInfoImageContainer">
                  <img
                    className="contentInfoImage"
                    src={withImageOptimizerBySizeAndType(image, defaultImageCropSize, imageFormat)}
                    alt={item.headline}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
  return null;
};
